// type Function = (...p: any[]) => any;

// export const compose = (...fns: Function[]) => {
//   return (...input: any) => {
//     return fns.reduceRight((acc, fn) => {
//       const params = [].concat(acc)
//       return fn(...params);
//     }, input);
//   };
// };

/* "zips" two arrays into object, the value of the first array are used as a keys,
 * and the values of the second one as values */
export const zipToObj = (keys: any[], values: any[]) => {
  return keys.reduce((o: any, key: string | number, i: number) => {
    o[key] = values[i];
    return o;
  }, {});
};

export const zip = (arr1: any[], arr2: any[]) => {
  return arr1.slice(0, arr2.length).map((element, i) => [element, arr2[i]]);
};

// as normal fn.call, except it checks if the fn function is indeed a function
// and also skips the "this" binding param, or rather assumes it is null
export const call = (fn?: (...p: any[]) => any, ...params: any[]) => {
  if (typeof fn === "function") fn.call(null, ...params);
};

// as the normal "bind", except it checks if the fn function is indeed a function
// and if it is not returns an empty one. Also skips the "this" binding param, or rather assumes it is null
export const bind = (fn?: (...p: any[]) => any, ...params: any[]) => {
  if (typeof fn !== "function") return () => {};

  return fn.bind(null, ...params);
};
